import './Slider.css';

function Slider(props){
    const getBackgroundSize = () => { 
        return { 
            backgroundSize: `${(props.value * 100) / props.max}% 100%` }; 
    }; 

    return (
        <div >
            <input
                type="range"
                min={props.min}
                max={props.max}
                style={getBackgroundSize()}
                value={props.value}
                onChange={(e) => props.onChange(Number(e.target.value))}                
            />  
        </div>
    );
}

export default Slider;